// extracted by mini-css-extract-plugin
export default {"rightCon":"index_rightCon_9hMHS"};